import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import axios from 'axios';
import $ from 'jquery';
import LocalStorageService from "../../utils/LocalStorageService";
import Constant from "../../utils/Constant";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Side_Bar_User from '../section/Side_Bar_User';
import List_Episode from '../section/List_Episode';
import Empty from '../section/Empty';
import Meta from '../section/Meta';
import MetaCreation from "../../utils/MetaCreation";
import Cookies from "js-cookie";
import { encrypt, decrypt, key } from "../../utils/encryptiondecryption";
class Watch_List extends React.Component{
    constructor(){
        super();
      
        this.callApi = this.callApi.bind(this);
      
        const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
        const decryptedText = decrypt(ciphertext, key);
        this.state = {
          auth: {
            device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
            phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
            user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
            mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
            package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
            subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
          },
    
            listDatas: {
                code: '',
                isLoaded: false,
                msg: 'Loading...',
                list: []
            },
            metaKeywords: '',
            metaTitle: '',
            metaDescription: '',
            metaImage: '',
            schema: ''       
        }
    }

    componentDidMount(){
        if (!this.state.auth.user_id) {
            let baseUrl = window.location.protocol + "//" + window.location.host;
            if (window.location.href.match(new RegExp("^" + baseUrl + "/.+"))) {
              if (!(window.location.href.includes("bd.mjunoon.tv/?msisdn") || window.location.href.includes("bd.mjunoon.tv?msisdn") || window.location.href.includes("localhost:3000/?msisdn") || window.location.href.includes("/about-us") || window.location.href.includes("/privacy-policy") || window.location.href.includes("/terms-and-conditions") || window.location.href.includes("/contact-us") || window.location.href.includes("/faqs"))) {
                window.location.href = "http://he.mjunoon.tv:8080/register";
              }
            }
        }
        MetaCreation.createMeta('static',window.location.pathname.replace(/^\/|\/$/g, ''),(e) => this.callMetaData(e));
        this.callApi();
        window.tagManagerEvent("Watch List Screen", "Watch List", "Watch List", {placement_channel: "", placement_program: "", placement_genre: "", user_gender: localStorage.getItem('gender') ? localStorage.getItem('gender') :"Unknown", user_age: localStorage.getItem('dob') ? Constant.getDateDiff(localStorage.getItem('dob'), Constant.currentDate) :"", user_interest: "", user_type: localStorage.getItem('mobile') ? 'real' : 'temp', user_behavior: Constant.currentEpocTime, custom_ga_client_id:  window.ga_client_id !== '' ? window.ga_client_id : '', email: localStorage.getItem('email') ? localStorage.getItem('email') :'', name : localStorage.getItem('name') ? localStorage.getItem('name') :'',  number : localStorage.getItem('mobile') ? localStorage.getItem('mobile') :'', search_keyword: '', user_custom_id : localStorage.getItem('user_id') ? localStorage.getItem('user_id') :'', user_device_id :''});
    }

    callMetaData = (metaResponse) =>{
        
        this.setState({
            metaKeywords : metaResponse.keywords,
            metaTitle : metaResponse.title,
            metaDescription : metaResponse.description,
            metaImage : metaResponse.thumbnail,
            schema : metaResponse.schema
        });
        let classRef = this;
        setTimeout(function () {
            window.metaUpdated();
        }, 1000);
    }

    callApi = () => {
      let classRef = this;
      let user_id = localStorage.getItem('user_id');
      axios({
          method: 'POST',
          url: Constant.url+"watch-list",
          data: {user_id: user_id},
          headers: {'Authorization': "bearer " + localStorage.getItem("access_token")}
        }).then(function (result) {
            let response = {};
            response["data"] = JSON.parse(LocalStorageService.decryptAes(result.data.eData));
          if(response.data.code === 200){
              
              classRef.setState({
                  listDatas:{
                      isLoaded : true,
                      list: response.data.data.episodes
                  }
              })
              window.imgNotFound();
          }else if(response.data.code === 400){
            classRef.setState({
                listDatas:{
                    code : 400
                }
            })
          }
      }).then(function (response) {
          
      });
    };
    
    render(){
        return(
           <div>
               {this.state.metaTitle !== '' ? <Meta schema ={null} metaKeywords = {this.state.metaKeywords} metaTitle={this.state.metaTitle} metaDescription={this.state.metaDescription}  metaImage={this.state.metaImage}/>: ''}
            {/*<Meta schema ={null} metaKeywords = {this.state.metaKeywords} metaTitle={this.state.metaTitle} metaDescription={this.state.metaDescription}  metaImage={this.state.metaImage}/>*/}
           <Header/> 
           <div class="content_sec">
           <div uk-height-match="target:  .h_match"> 
                <Side_Bar_User/>
                  <div class="h_match asad_bg"> 
                  <section class="pad_left pad_right pad_tb prog_box_sec">            
                      {this.state.listDatas.isLoaded === true ? <List_Episode name = "Watch List" data = {this.state.listDatas.list}/>:( this.state.listDatas.isLoaded === false && this.state.listDatas.code !== 400) ? <div class="loader_box"><div class="loader"><div class="loader_inner"></div></div></div> :<Empty image = "/images/icons/ic_watchlist.png" name = "Watch List"/>}                      
                  </section>
          </div>
            </div>    
            </div>        
           <Footer/>    
           </div>
        );
     }    
}

export default withRouter(Watch_List);